<template>
  <div>
    <div class="text-center section">
      <div class="d_flex_btwn mb_10">
        <h2 class="h2">Shifts calendar</h2>
        <h4 class="color_green">
          <router-link v-if="viewLink" :to="{ name: 'working-shifts-calendar' }"
            >View shifts</router-link
          >
        </h4>
      </div>
      <v-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        disable-page-swipe
        is-expanded
      >
        <template v-slot:day-content="{ day, attributes }">
          <div class="flex flex-col h-full z-10 overflow-hidden">
            <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
            <div class="flex-grow overflow-y-auto overflow-x-auto">
              <p
                v-for="attr in attributes"
                :key="attr.key"
                class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
                :title="
                  attr.customData.shift_name + ' / ' + attr.customData.key
                "
              >
                <span v-if="attr.customData.shift_id">
                  {{ attr.customData.shift_name }} /
                  <span :style="{ color: attr.customData.color }">{{
                    attr.customData.key
                  }}</span>
                  <span v-if="attr.customData.is_compensatory">
                    <span
                      v-if="attr.customData.is_compensatory_credited"
                      class="credited_comp"
                      title="Compensatory approved"
                      >CS</span
                    >
                    <span
                      v-else
                      class="normal_comp"
                      title="Compensatory scheduled"
                      >CS</span
                    ></span
                  >
                </span>
                <span v-else>
                  {{ attr.customData.formatted_custom_start_time }} -
                  {{ attr.customData.formatted_custom_end_time }}
                  <span v-if="attr.customData.is_compensatory">
                    <span
                      v-if="attr.customData.is_compensatory_credited"
                      class="credited_comp"
                      title="Compensatory approved"
                      >CS</span
                    >
                    <span
                      v-else
                      class="normal_comp"
                      title="Compensatory scheduled"
                      >CS</span
                    ></span
                  >
                </span>
              </p>
            </div>
          </div>
        </template>
      </v-calendar>
      <div class="col_12">
        <shift-table-component :show="showTable" :shifts="shifts" />
      </div>
    </div>
  </div>
</template>

<script>
import ShiftTableComponent from '../users/ShiftTableComponent.vue';
import { mapGetters } from 'vuex';
export default {
  components: { ShiftTableComponent },
  props: {
    showTable: {
      type: Boolean,
      default: true,
    },
    viewLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      shifts: [],
    };
  },
  created() {
    this.getShifts();
    this.loadData();
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  methods: {
    getShifts() {
      this.axios.get('/active-shifts-for-relation').then(({ data }) => {
        this.shifts = data.data;
      });
    },
    loadData() {
      this.axios
        .get('/assigned-shifts-for-calender/' + this.user.id)
        .then((response) => {
          this.attributes = response.data.data;
        });
    },
  },
};
</script>
<style scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}

::v-deep(.custom-calendar.vc-container) {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;
}

::v-deep(.custom-calendar.vc-container .vc-header) {
  /* background-color: #f1f5f8; */
  /* padding: 10px 0; */
  height: 48px;
  margin-top: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weeks) {
  padding: 0;
}

::v-deep(.custom-calendar.vc-container .vc-weekday) {
  background-color: var(--weekday-bg);
  border-bottom: var(--weekday-border);
  border-top: var(--weekday-border);
  padding: 5px 0;
}

::v-deep(.custom-calendar.vc-container .vc-day) {
  padding: 0 5px 3px 5px;
  text-align: left;
  height: var(--day-height);
  min-width: var(--day-width);
  background-color: white;
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1),
::v-deep(.custom-calendar.vc-container .vc-day.weekday-7) {
  background-color: #eff8ff;
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-bottom)) {
  border-bottom: var(--day-border);
}
::v-deep(.custom-calendar.vc-container .vc-day.weekday-1:not(.on-bottom)) {
  border-bottom: var(--day-border-highlight);
}
::v-deep(.custom-calendar.vc-container .vc-day:not(.on-right)) {
  border-right: var(--day-border);
}

::v-deep(.custom-calendar.vc-container .vc-day-dots) {
  margin-bottom: 5px;
}

::v-deep(.custom-calendar .vc-header .vc-title-wrapper .vc-title) {
  /* opacity: 1 !important; */
  /* background: red !important; */
  /* color: red; */
  background: transparent;
}
::v-deep(.custom-calendar .vc-header .vc-title:hover) {
  opacity: 1;
}

::v-deep(.custom-calendar .vc-weeks .vc-day) {
  text-align: center;
  padding: 5px;
  min-height: 60px;
  height: auto;
}
::v-deep(.custom-calendar .bg-info) {
  background: rgba(66, 153, 225);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-success) {
  background: rgba(56, 178, 172);
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .bg-green) {
  background: #16a34a;
  color: #fff;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
}
::v-deep(.custom-calendar .credited_comp) {
  background: #16a34a;
  margin-left: 5px;
  color: #ffffff;
  padding: 1px 5px;
}
::v-deep(.custom-calendar .normal_comp) {
  background: rgba(66, 153, 225);
  margin-left: 5px;
  color: #ffffff;
  padding: 1px 5px;
}
.color_green {
  color: #16a34a;
}
.text-danger {
  color: #dc2626;
}
.float-right {
  float: right;
  cursor: pointer;
}
</style>
